// API configuration — set REACT_APP_API_URL in .env (build + dev server read it).
// Pattern: crator-hit-web/src/config/api.ts uses VITE_API_BASE_URL + import.meta.env.
//
// Local:   http://api.garbagevalue.local/api/  or  http://localhost:3003/api/
// Production: https://api.garbagevalue.com/api/

console.log('process.env', process.env);
export const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://garbage-api:3000/api/').trim();
